import Vue from 'vue'
import Vuex from 'vuex'

import LayoutModule from '@/store/modules/layout'
import FormModule from '@/store/modules/form'
import TeamRegistrationModule from '@/store/modules/team-registration'
import TournamentModule from '@/store/modules/tournament'

Vue.use(Vuex)

const store = new Vuex.Store({
  actions: {
    clearStore({ commit }) {
      commit('form/clear')
      commit('teamRegistration/clear')
      // TODO: Set property ID
      // TODO: Set subproperty ID
    },
  },
  modules: {
    layout: LayoutModule,
    form: FormModule,
    teamRegistration: TeamRegistrationModule,
    tournament: TournamentModule,
  },
})

export default store
